import { PIOversightStatus } from '../../../types/pi_oversight.types';
export const getStatusBadgeVariant = (status) => {
    switch (status) {
        case PIOversightStatus.OVERDUE:
            return 'danger';
        case PIOversightStatus.REVIEW_REQUIRED:
            return 'incomplete';
        case PIOversightStatus.CURRENT:
            return 'common';
        default:
            return 'common';
    }
};
export const getTableRowCustomClasses = (row) => {
    switch (row.status) {
        case PIOversightStatus.OVERDUE:
            return 'bg-red-50 hover:bg-red-50';
        case PIOversightStatus.REVIEW_REQUIRED:
            return 'bg-yellow-50 hover:bg-yellow-50';
        default:
            return '';
    }
};
